// Typed access to the shared first-party host check.
//
// The implementation lives in api/_firstPartyHost.js as plain ESM so
// middleware.ts (Vercel Edge Middleware, repo root) can import it without a
// build step. This module is the app's entry point to it: import from
// '@/config/customDomainHost' anywhere in src/, never reach into api/
// directly. Mirrors src/utils/publicLeagueSeo.ts's relationship to
// api/_publicLeagueSeo.js.

import * as firstPartyHost from '../../api/_firstPartyHost.js';

/** True when `hostname` is one of StatHarbour's own hosts (see api/_firstPartyHost.js). */
export const isFirstPartyHost: (hostname: string) => boolean = firstPartyHost.isFirstPartyHost;

/**
 * Injected by api/public-league.js when it server-renders "/" on a customer
 * domain, so RootRoute can render the public hub for these exact ids with no
 * client-side resolver round trip and no loading flash. Absent on every
 * first-party host, and on a client-side navigation or a cached shell on a
 * customer domain (CustomDomainRoute handles that fallback instead).
 */
declare global {
  interface Window {
    __STATHARBOUR_DOMAIN__?: {
      leagueId: string;
      seasonId: string;
      view?: 'club' | 'player' | 'game' | null;
      entityId?: string | null;
    };
  }
}
